import React from "react";
import "./index.css";

export default function Loader() {
  return (
    <div className="loaderContainer">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
